<template>
  <label
    v-if="labelText"
    class="sc3-form-label"
    :class="{
      'sc3-form-label-inline': isInline,
      'sc3-form-label-small': isInline
    }"
    :for="htmlId"
  >{{ labelText }}</label>
  <br v-if="labelText" />
  <select
    :id="htmlId"
    class="sc3-select-menu sc3-select-menu-compact sc3-select-menu-white-and-grey"
    :class="{ 'sc3-select-menu-inline': isInline }"
    v-model="range"
    @change="handleRangeMenuChanged()"
  >
    <template
      v-for="rangeOption in RANGE_OPTIONS_ARRAY"
      :key="rangeOption.title"
    >
      <option
        v-if="rangeOption.dividerAbove"
        disabled
      >&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;</option>
      <option :value="rangeOption.title">{{ rangeOption.title }}</option>
    </template>
  </select>
</template>

<script lang="ts" setup>
  import { ref, toRefs, watch } from 'vue';
  import { storeToRefs } from 'pinia';
  import { useChartStore } from '@/stores/chartStore';
  import { useAuthentication } from '@/composables/useAuthentication';
  import { useModals } from '@/composables/useModals';
  import { RANGE_OPTIONS_ARRAY, getRangeObjFromRangeTitle } from '@/enums/range-options';

  const chartStore = useChartStore();
  const { range: chartStoreRange } = storeToRefs(chartStore);
  const { isLoggedIn, isBasic, isExtra } = useAuthentication();
  const {
    launchCreateAccountModal,
    launchUpgradeToExtraModal,
    launchUpgradeToProModal
  } = useModals();
  const props = defineProps<{
    isInline: boolean;
    labelText: string;
    htmlId: string;
  }>();
  const { isInline, labelText, htmlId } = toRefs(props);

  const range = ref(chartStoreRange.value);

  function handleRangeMenuChanged() {
    const rangeOption = getRangeObjFromRangeTitle(range.value);

    if (
      !isLoggedIn.value &&
      !rangeOption.isAllowedForFreeUsers
    ) {
      syncRange();
      launchCreateAccountModal();
      return;
    }

    if (
      (!isLoggedIn.value || isBasic.value) &&
      !rangeOption.isAllowedForBasicMembers
    ) {
      syncRange();
      launchUpgradeToExtraModal();
      return;
    }

    if (
      (!isLoggedIn.value || isBasic.value || isExtra.value) &&
      !rangeOption.isAllowedForExtraMembers
    ) {
      syncRange();
      launchUpgradeToProModal();
      return;
    }

    chartStoreRange.value = range.value;
  }

  function syncRange() {
    range.value = chartStoreRange.value;
  }

  watch(chartStoreRange, syncRange);
</script>
